// extracted by mini-css-extract-plugin
export default {"root":"Blockquote_root__MOXHe"};